import React from 'react';
import 'twin.macro';
import Select from 'components/Form/Select2';
import { useTranslation } from 'react-i18next';
import { ZoneId } from 'types/zone';

interface Props {
  onChange: (v: ZoneId) => void;
  value?: string;
  extraLarge?: boolean;
  large?: boolean;
}

type AustralianStateCode =
  | 'ACT'
  | 'NSW'
  | 'NT'
  | 'QLD'
  | 'SA'
  | 'TAS'
  | 'VIC'
  | 'WA';

export const australianStates: {
  label: string;
  zoneId: ZoneId;
  code: AustralianStateCode;
}[] = [
  {
    label: 'Australian Capital Territory',
    zoneId: 'australian-capital-territory',
    code: 'ACT',
  },
  { label: 'New South Wales', zoneId: 'new-south-wales', code: 'NSW' },
  { label: 'Northern Territory', zoneId: 'northern-territory', code: 'NT' },
  { label: 'Queensland', zoneId: 'queensland', code: 'QLD' },
  { label: 'South Australia', zoneId: 'south-australia', code: 'SA' },
  { label: 'Tasmania', zoneId: 'tasmania', code: 'TAS' },
  { label: 'Victoria', zoneId: 'victoria', code: 'VIC' },
  { label: 'Western Australia', zoneId: 'western-australia', code: 'WA' },
];

export function AustralianStateSelector(props: Props) {
  const { onChange, value = 'victoria' } = props;
  const { t } = useTranslation(['zone']);
  return (
    <Select<string>
      portal
      options={australianStates.map(({ label, zoneId }) => ({
        value: zoneId,
        label,
        disabled: zoneId !== 'victoria',
      }))}
      data-testid="australian-state-button-selector"
      value={value}
      tw="bg-white"
      large={props.large}
      extralarge={props.extraLarge}
      label={t('zone:state')}
      onChange={onChange}
    />
  );
}
